import VueGtm from "@gtm-support/vue2-gtm";
import Vue from "vue";
export function setVueGtm(gtmTagId, router) {
  Vue.use(VueGtm, {
    id: gtmTagId,
    vueRouter: router,
  });
}
